// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__egc0R","success":"tag_success__N4rNC","primary":"tag_primary__ABvw1","primaryLighter":"tag_primaryLighter__XFM5o"};